import { render, staticRenderFns } from "./catalogoProductos.vue?vue&type=template&id=1e8ba093&scoped=true&"
import script from "./catalogoProductos.vue?vue&type=script&lang=js&"
export * from "./catalogoProductos.vue?vue&type=script&lang=js&"
import style0 from "./catalogoProductos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./catalogoProductos.vue?vue&type=style&index=1&id=1e8ba093&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8ba093",
  null
  
)

export default component.exports